import digitsExempt from '../../../../../form/field-validation/digitsExempt';
import digitsOnly from '../../../../../form/field-validation/digitsOnly';
import stripCharacters from '../../../../../utils/strip-characters';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import * as max from '../../max-length-validators';
import * as min from '../../minLengthValidators';
import * as required from '../../required-validators';

const formatDKPostcode = (value) => {
  if (!value) return value;
  return value.replace(/\s/g, '');
};

const FieldDefinitionDK = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    minLength: 3,
    maxLength: 4,
    transform: formatDKPostcode,
    validate: [required.postCode, digitsOnly(), min.lengthPostCode(3), max.lengthPostCode(4)],
    validationCleaner: stripCharacters(' '),
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  {
    name: 'townCity',
    label: 'checkout.delivery.address.field.label.town.text',
    required: true,
    maxLength: 35,
    validate: [required.townCity, digitsExempt(), max.lengthAddress(35)],
  },
  county,
];

export default FieldDefinitionDK;
